import { render } from "./BankAccounts.vue?vue&type=template&id=7df25d24&scoped=true"
import script from "./BankAccounts.vue?vue&type=script&lang=js"
export * from "./BankAccounts.vue?vue&type=script&lang=js"

import "./BankAccounts.vue?vue&type=style&index=0&id=7df25d24&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7df25d24"

export default script